import React from 'react';

/** 12 squares, 4 per row in word order; solved / missed / current / upcoming. */
function DozenProgress({ wordLengths = [], progress = [], currentPosition = null, size = 'md' }) {
  const byPosition = new Map(progress.map((p) => [p.position, p]));
  return (
    <div className={`dozen-progress dozen-progress--${size}`} aria-label="Прогресс">
      {wordLengths.map((length, position) => {
        const entry = byPosition.get(position);
        const state = entry
          ? entry.outcome === 'solved'
            ? 'solved'
            : 'missed'
          : position === currentPosition
            ? 'current'
            : 'pending';
        return (
          <span
            key={position}
            className={`dozen-progress__cell dozen-progress__cell--${state}`}
            title={`${length} букв`}
          >
            {size === 'lg' && entry?.outcome === 'solved' ? entry.points : ''}
          </span>
        );
      })}
    </div>
  );
}

export default DozenProgress;
